import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {CommonModule, NgForOf, NgIf} from "@angular/common";
import {NgSelectModule} from "@ng-select/ng-select";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import {LabeledInputComponent} from "../../../shared/labeled-input/labeled-input.component";
import {SharedModule} from "../../../shared/shared.module";
import {TemplateService} from "../../../_services/template.service";
import {SpecificationQuestionsService} from "../../../_services/specification-questions.service";
import {ToastrService} from "ngx-toastr";
import {QuoteService} from "../../../_services/quote.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomerService} from "../../../_services/customer.service";
import {Fitrite365Template} from "../../../_models/Fitrite365Template";
import {SpecificationQuestionsRequestIds} from "../../../_models/SpecificationQuestionsRequestIds";
import {SpecificationAnswer} from "../../../_models/SpecificationAnswer";
import {Customer} from "../../../_models/Customer";
import {BaseComponent} from "../../../shared/base-component";
import {BespokeQuoteCreationRequest} from "../../../_models/BespokeQuoteCreationRequest";
import {SweetAlert2Module} from "@sweetalert2/ngx-sweetalert2";
import {catchError, map} from "rxjs/operators";
import {of} from "rxjs";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: true,
  templateUrl: './create-bespoke-quote.component.html',
  imports: [
    CommonModule,
    NgSelectModule,
    CommonModule,
    CommonModule,
    CommonModule,
    ReactiveFormsModule,
    LabeledInputComponent,
    SharedModule,
    NgSelectModule,
    CommonModule,
    FormsModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgForOf,
    NgIf,
    SweetAlert2Module,
    NgbTooltip
  ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['create-bespoke-quote.component.css']
})

export class CreateBespokeQuoteComponent extends BaseComponent implements OnInit {
  constructor(private templateService: TemplateService, private formBuilder: FormBuilder, private questionService: SpecificationQuestionsService,
              toasterService: ToastrService, private quoteService: QuoteService, private route: ActivatedRoute,
              private customerService: CustomerService, private router: Router) {
    super(toasterService)
  }

  public template: Fitrite365Template;
  public colourSearchCriteria: SpecificationQuestionsRequestIds = new SpecificationQuestionsRequestIds();
  public balustradeColours: SpecificationAnswer[];
  public deckColours: SpecificationAnswer[];
  public colourOptions: SpecificationAnswer[];
  ids: number[] = [];
  templateId = '';
  public parks: Customer[] = [];

  quoteForm = this.formBuilder.group({
    customerName: new FormControl(null, [Validators.required]),
    customerEmail: new FormControl(null, [Validators.required]),
    customerPhone: new FormControl(null, [Validators.required]),
    templateId: new FormControl(null),
    numberOfGates: new FormControl(null, [Validators.required]),
    numberOfStepSets: new FormControl(null, [Validators.required]),
    sqFt: new FormControl(null),
    deckColour: new FormControl(null, [Validators.required]),
    numberOfHatches: new FormControl(null, [Validators.required]),
    balustradeColour: new FormControl(null, [Validators.required]),
    comments: new FormControl(null),
    plot: new FormControl(null, [Validators.required]),
    customerId: new FormControl(null),
    measurements: new FormArray([]),
    deckSkirted: new FormControl(null),
    caravanSkirted: new FormControl(null),
    caravanHeight: new FormControl(2, [Validators.required]),
  })

  ngOnInit() {
    this.templateId = this.route.snapshot.paramMap.get('templateId');
    this.quoteForm.patchValue({
      deckSkirted: false,
      caravanSkirted: false
    });
    this.getTemplate();
    this.getColours();
    this.getParks();
  }

  getTemplate() {
    this.templateService.getBespokeTemplateById(this.templateId)
      .subscribe(template => {
        this.template = template;
        const count = Number(this.template.measurements);

        for (let i = 0; i < count; i++) {
          const label = this.getLetter(i);
          this.addMeasurement(label);
        };
      })
  }

  getColours() {
    this.colourSearchCriteria.ids = [3, 4];
    this.questionService.getSpecificationQuestions(this.colourSearchCriteria)
      .subscribe(questions => {
        this.balustradeColours = questions.find((x) => x.id == 3).specificationAnswers;
        this.deckColours = questions.find((x) => x.id == 4).specificationAnswers;
      })
  }

  createQuote() {
    if (this.isLoading || !this.quoteForm.valid) {
      return;
    }

    const quote = this.quoteForm.value;
    quote.templateId = this.template?.id;

    const request = Object.assign(new BespokeQuoteCreationRequest(), this.quoteForm.value);

    request.measurements = (this.f.measurements as FormArray).controls.map((group: FormGroup) => ({
      label: group.get('label').value,
      measurement: group.get('measurement').value
    }));

    this.quoteService.createBespokeQuote(request)
      .pipe(
        map(q => {
          this.toasterService.success('Quote Created');
          this.router.navigate(['/quotes/' + q.id]);
        }),
        catchError(e => {
          this.toasterService.error(e);
          return of();
        }))
      .subscribe()
  }

  getParks() {
    //TODO this needs actually doing, rather than a placeholder
    this.customerService.getCustomersByUser()
      .subscribe(customers => {
        this.parks = customers;
      })
  }

  addMeasurement(label: string) {
    (this.f.measurements as FormArray).push(
      new FormGroup({
        label: new FormControl(label),
        measurement: new FormControl()
      })
    );
  }

  get measurements() {
    return (this.f.measurements as FormArray).controls as FormControl[];
  }

  get f() {
    return this.quoteForm.controls;
  }

  getLetter(i: number) {
    return String.fromCharCode(65 + (i % 26));
  }

  getLabel(i: number) {
    let letter = String.fromCharCode(65 + (i % 26));
    return 'Measurement ' + letter + ' (ft)';
  }
}
